import React from 'react';
import ContestLanding from '../../views/common/ContestLanding';
import '../../css/Settings.css';

import 'react-images-uploader/src/styles/styles.css';
import 'react-images-uploader/src/styles/font.css';
import { Container, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import HmAjax from '../../util/HmAjax';
import "../../css/components/ImageLoader.css";
import ImageUpload from '../../../src/components/imageLoader/ImageUpload';
import HmEventRegistry from '../../model/HmEventRegistry';

class ContestProfileSettings extends ContestLanding {

    constructor(props) {
        super(props);

        this.state = {
            userid: this.getUser().getLoginId(),
            name: this.getUser().getUserName(),
            useremail: this.getUser().getEmail(),
            mobile: this.getUser().getMobile(),
            modeId: this.getUser().getModeID(),
            locale: this.getUser().getLocale(),
            authProviderId:this.getUser().getAuthProviderId(),
            oldPassword: "",
            password: "",
            passwordConfirm: "",
            userimage: "",
            msg: "",
            modal: false,
            RegistrationOpen: false,
            loggedIn: true  //Overriding to reduce repeated componentMounts
        };

        this.dataUpdate=true;

        //Setting default state to clear
        this.defaultState = this.state;

        this.handleChange = this.handleChange.bind(this);
        this.handlePasswrdChange = this.handlePasswrdChange.bind(this);
        this.handleImgChange = this.handleImgChange.bind(this);
        this.storevalues = this.storevalues.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.toggle = this.toggle.bind(this);

        this.registrationChecked = false;

        this.LangSelect = this.LangSelect.bind(this);
    }

    componentDidMount(){
        //super.componentDidMount();
        this.getRegistrationStatus();
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    getRegistrationStatus(){
        let me=this;
        var callBackSuccess = function(response){

          if(response !== null){
            console.log("RegistrationOpen ",response);
            let RegistrationOpen  = response.regnActive;
            if(RegistrationOpen){
              me.setState({RegistrationOpen: true});    
          }else{
              me.setState({RegistrationOpen: false});
          }
      }
  }


  var callBackFailure = function(response){
                //console.log("userRegisterForm failure",response);
              // me.setState({RegistrationOpen: false});
          }
          let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup() : null;

          if(!me.registrationChecked){
            me.registrationChecked = true;
            new HmAjax(this.getUrlFor("CONTEST_REGISTRATION_STATUS").replace("{#contestId}",contestId)).get(callBackSuccess, callBackFailure);
        }

    }
    
    isPilotUser(){
        return this.getUser().isPilotUser();        
    }

    toggle(e) {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleChange(e) {
        e.target.classList.add('active');
        this.setState({
            [e.target.name]: e.target.value,
        });
        this.dataUpdate=false;
        if (e.target.name !== "fileInput") {
            this.showInputError(e.target.name);
            
        } else {
            // this.showImageError(e.target.name);
        }

    }

    LangSelect(e){
        var x= e.target.value;
        ///console.warn("Language "+x);
        this.setLocale(x);
        this.dataUpdate=false;
        this.setState({
            locale: x
        });
    }

    getLangField(){
        let me = this;
        let locales = this.getLocales()
        let isMuliLangAvailable = (locales && locales.length > 1) ? true : false;

        if(this.isPilotUser() && isMuliLangAvailable){
         return(
            <div className="form-group">

            <label className="form-inline">
            <span>
            {this.rb("profile.change.lang")}
            </span>

            <select onChange={this.LangSelect} id="userlang" className="form-control"
            type="text"
            name="userlang"
            ref="userlang"
            value={this.state.locale}
            placeholder="Email">
            {locales.map((key,idx) =>
                <option value={key}>{me.rb(key)}</option>)
            }
            </select>

            </label>
            <div className="error" id="useremailError" />

            </div>
            )
        }else{
            return (<div></div>);
        }

    }

    handlePasswrdChange(e) {
        e.target.classList.add('active');
        this.setState({
            [e.target.name]: e.target.value,
        });
        this.dataUpdate=false;
        if (e.target.name !== "fileInput") {
            this.showPasswrdError(e.target.name);
        } else {
            // this.showImageError(e.target.name);
        }
        
    }

    handleImgChange(imageUrl) {
        //image changes
       // this.updateImage(imageUrl);
       if(typeof this.props.callbackHomeUpdateImage === "function"){
        this.props.callbackHomeUpdateImage(imageUrl);
    }     
}

submitdata(fData, myData) {
    for (var i in fData) {
        console.log(fData[i]+" == "+myData[i])
        if (fData[i] !== myData[i] && myData[i] !== undefined) {
            return false;
        }
    }
    return true;
}

handleSubmit(e) {
    e.preventDefault();
    var newData = {};
    var oldData = {};
    var eq = true;
    var status = "";
    var me=this;


    if (!this.showFormInputErrors() || !this.showFormPassErrors()) {
        status = "error";
    } else {
        newData = this.state;
        oldData = this.defaultState;
        eq = this.submitdata(newData, oldData);
        if (!eq) {
            status = "success";
            me.storevalues()
                /*if(this.showFormPassErrors()){
                    this.passReset()
                }*/
                this.dataUpdate=true;
            } else {
                status = "no changes";
            }
        }
        
        // console.log("old state")
        // console.log(oldData)
        // console.log("-------------------")
        // console.log("current state")
        // console.log(newData)
        // console.log("*******")
        // console.log(status)
        

    }
    trackProfileChanges(status){
    	var isPwdChanged = false;
    	if(status){
    		isPwdChanged = this.state.password.length > 0;
    	}else{
    		isPwdChanged = false;
    	}
    	 //try{
         var trackObj = {
             "name" : this.state.name,
             "password_changed": isPwdChanged,
             "result": status
         }
         this.initiateTrack("profile_change_evaluated", trackObj);
	     //}catch(e){}
    }

    storevalues() {
        var formData = {
            "loginId": this.state.userid,
            "userName": this.state.name,
            "emailId": this.state.useremail,
            "currentPassword": this.state.password,
            "oldPassword": this.state.oldPassword,
            "locale":this.state.locale
        }

        for (var i in formData) {
            if (formData[i] === null || formData[i].length < 1) {
                delete formData[i];
            }
        }

        var me = this;
        var callBackSuccess = function (response) {
            if (response !== null) {
                //Update userStore
                if(response.user && response.user.userId){
                    me.getUser().store(response.user);
                }

                //Changing default state tp new state
                var msg = "";
                if (response.status === "SUCCESS") {
                    msg = me.rb("profile.saved_msg");
                    me.defaultState = me.state;
                    me.sessionCheck();
                    if(typeof me.props.userNameUpdateEvent === "function"){
                        me.props.userNameUpdateEvent(response.user.userName || response.user.userId);
                    }                    
                    me.trackProfileChanges(true);
                } else {
                    var replaceVal = (response.status.split("||").length > 1) ? response.status.split("||")[1] : "";
                    msg = me.rb(response.status.split("||").length > 0 ? response.status.split("||")[0] : response.status).replace("#1", replaceVal);
                    me.trackProfileChanges(false);
                }
                me.state.msg = msg;

                var buttons = [{
                    label: me.rb("btn.ok"),
                    handler: () => { }
                }]

                me.passReset();
                me.showAlert(" ", msg, buttons)
                //me.toggle()
            }
            //console.log("response : ", response);
        }

        var callBackFailure = function (response) {
            console.log("response : ", response);
            var msg = me.rb("profile.oops");
            me.state.msg = msg;

            var buttons = [{
                label: me.rb("alert.ok"),
                handler: () => { }
            }]
            me.trackProfileChanges(false);
            me.passReset();
            me.showAlert(" ", msg, buttons);
        }
        new HmAjax(this.getUrlFor("PROFILE_UPDATE"), formData).mask().post(callBackSuccess, callBackFailure);
    }

    handleClear(e) {
        e.preventDefault();
        this.formReset();
        this.setState(this.defaultState);
        this.afterReset();
        console.log("clear");
    }

    afterReset(){
        try{
            let oldLocale = this.defaultState.locale; 
            //Reset to older language
            this.setLocale(oldLocale);
        }catch(e){
            console.error(e);
        }
    }

    showFormInputErrors() {
        const inputs = document.querySelectorAll('.inputopt');
        let isFormValid = true;
        inputs.forEach(input => {
            //console.log("input.name "+input.name)
            if (input.name.length > 0 && input.name !== 'filesInput') {
                input.classList.add('active');
                const isInputValid = this.showInputError(input.name);
                if (!isInputValid) {
                    isFormValid = false;
                }
            }
        });
        return isFormValid;
    }

    showFormPassErrors() {
        const inputs = document.querySelectorAll('.inputpass');
        let isFormValid = true;
        inputs.forEach(input => {
            //console.log("showFormPassErrors "+input.value)
            var oPass = this.state.oldPassword.length;
            var nPass = this.state.password.length;
            var cPass = this.state.passwordConfirm.length;
            var tPass = oPass + nPass + cPass;

            if (input.name.length > 0 && input.name !== 'filesInput' && tPass > 0) {
                input.classList.add('active');
                const isInputValid = this.showPasswrdError(input.name);
                if (!isInputValid) {
                    isFormValid = false;
                }
            } else {
                input.classList.remove('active');
                const error = document.getElementById(`${input.name}Error`);
                error.textContent = '';
            }

        });
        return isFormValid;
    }

    formReset() {
        const inputs = document.querySelectorAll('input');
        if(inputs && inputs.length > 0){
            inputs.forEach(input => {
                if (input && input.name.length > 0 && input.name !== 'filesInput') {
                //console.log("remove" + input.name + " " + input.classList)
                input.classList.remove('active');
                const error = document.getElementById(`${input.name}Error`);
                if(error){
                    error.textContent = '';    
                }                
            } else if (input && input.name === 'filesInput') {
                //Image validation
            }
        });
        }
    }

    passReset(){
        const inputs = document.querySelectorAll('.inputpass');
        inputs.forEach(input => {
            console.log("passReset "+input.value)
            this.setState({
                oldPassword: "",
                password: "",
                passwordConfirm: ""
            });
            input.classList.remove('active');
            const error = document.getElementById(`${input.name}Error`);
            error.textContent = '';
        });
    }

    showImageError(refName) {
        const validity = document.getElementById(`${refName}`).files;
        const label = "Image"; //document.getElementById(`${refName}`).placeholder;
        const error = document.getElementById(`${refName}Error`);

        if (validity.length < 1) {
            error.textContent = `${label} is a required field`;
            return false;
        }
        error.textContent = '';
        return true;
    }

    showInputError(refName) {
        const validity = this.refs[refName].validity;
        const label = document.getElementById(`${refName}Label`).placeholder;
        const error = document.getElementById(`${refName}Error`);
        console.log("validity ", validity);
        if (!validity.valid) {
            if (validity.valueMissing) {
                error.textContent = `${label} is a required field`;
            } else if (validity.typeMismatch) {
                error.textContent = `${label} should be a valid email address`;
            } else if (validity && validity.tooShort) {
                error.textContent = `${label} must be between 6 and 50 characters`;
            } 
            return false;
        }
        error.textContent = '';
        return true;
    }

    specialchar(string){
        var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
        if(string.match(format) ){
            return true;
        }else{
            return false;
        }
    }

    showPasswrdError(refName) {
        const validity = this.refs[refName].validity;
        var labspl=document.getElementById(`${refName}Label`).placeholder.split("*")
        console.log("labspl "+labspl[0])
        const label =labspl[0];
        const error = document.getElementById(`${refName}Error`);
        // console.log("refName " + refName)

        const isPassword = refName.indexOf('password') !== -1;
        const isPasswordConfirm = refName === 'passwordConfirm';

        const oPassword = this.refs.oldPassword.value.length;
        const nPassword = this.refs.password.value.length;
        const cPassword = this.refs.passwordConfirm.value.length;

        //console.log("refName " + refName)

        if (isPasswordConfirm) {
            if (this.refs.password.value !== this.refs.passwordConfirm.value) {
                this.refs.passwordConfirm.setCustomValidity(this.rb("rpwd.doesnotmatch"));
            } else {
                this.refs.passwordConfirm.setCustomValidity('');
            }
        }

        if (!validity.valid) {
            if (validity.valueMissing) {
                error.textContent = `${label} is a required field`;
            } else if (isPassword && validity.patternMismatch) {
                error.textContent = `${label} should be longer than 5 chars`;
            } else if (isPasswordConfirm && validity.customError) {
                error.textContent = this.rb("rpwd.doesnotmatch");
            }
            return false;
        }
        error.textContent = '';
        return true;
    }

    render() {
        let me=this;
        
        return super.render(
            <form noValidate>
            <div id="Settings" className="cont_settings">

            <Row>
            <Col><h2 className="acc_title">{this.rb("profile.title")}</h2></Col>
            </Row>
            <Row>
            <Col><label className="label-title">{this.rb("profile.aboutme")}</label></Col>
            </Row>
            <Row>
            <Col xs="12" lg="3" md="4" sm="12">
            <div className="form-group" align="center">
            <ImageUpload checktype="image" callback={this.handleImgChange} required/>

                                {/* <ImagesUploader
                                    url="E:\"
                                    optimisticPreviews
                                    checktype="image"
                                    placeholder="image"
                                    value="{this.state.inputId}"
                                    multiple={false}
                                    size='200'
                                    required
                                    onLoadEnd={(err) => {
                                        if (err) {
                                            //this.loadState: '',
                                            console.error(err);
                                        }
                                        //console.error(err);
                                    }}
                                /> */}

                                <div className="error" id="filesInputError" />
                                </div>
                                </Col>


                                <Col xs="12" lg="auto" md="auto" sm="12">
                                <br /><br />
                                <div className="form-group">
                                <label className="form-inline"><span>{this.rb("profile.user_id")}:</span>
                                <input id="useridLabel" className="form-control"
                                type="text"
                                name="userid"
                                ref="userid"
                                maxLength='50'
                                placeholder="UserID"
                                size="40"
                                value={this.state.userid}
                                onChange={this.handleChange}
                                required disabled/>
                                </label>
                                <div className="error" id="useridError" />
                                </div>
                                

                                <div className="form-group">
                                <label className="form-inline"><span>{this.rb("profile.user_name")}:</span>

                                <input id="nameLabel" className="form-control inputopt"
                                type="text"
                                name="name"
                                ref="name"
                                minLength="6"
                                maxLength='50'
                                placeholder="Username"
                                size="40"
                                value={this.state.name}
                                onChange={this.handleChange}
                                required disabled={!this.state.RegistrationOpen}/>

                                </label>
                                <div className="error" id="nameError" />

                                </div>


                                {
                                    (()=>{

                                        if(((me.state.mobile) && (me.state.mobile.length>0)) || ((me.state.useremail) && (me.state.useremail.length>0))){
                                            return(
                                            <div className="form-group">

                                            <label className="form-inline">
                                            <span>
                                            {( () => {
                                                if(me.state.modeId == "2" || me.state.modeId == 2){
                                                    return (
                                                    me.rb("register.phone")
                                                    );
                                                }else{
                                                    return (
                                                    me.rb("profile.email_id")
                                                    );
                                                }
                                            })()}
                                            :
                                            </span>

                                            <input id="useremailLabel" className="form-control"
                                            type="text"
                                            name="useremail"
                                            ref="useremail"
                                            maxLength='50'
                                            placeholder="Email"
                                            size="40"
                                            value={(me.state.modeId == "2" || me.state.modeId == 2) ? me.state.mobile : me.state.useremail}
                                            required disabled />
                                            </label>
                                            <div className="error" id="useremailError" />

                                            </div>
                                            )
                                        }

                                    })()
                                }

                                {this.getLangField()}
                                </Col>
                                </Row>

                                {(() => {                    	
                                  if(parseInt(this.state.authProviderId) <= 1){
                                   return(
                                   <div>
                                   <Row>
                                   <Col><label className="label-middle">{this.rb("profile.change_password")}</label></Col>
                                   </Row>

                                   <Row>
                                   <Col xs="12" lg="3" md="4" sm="12"></Col>

                                   <Col xs="12" lg="auto" md="auto" sm="12">
                                   <div className="form-group">
                                   <input id="oldPasswordLabel" className="form-control inputpass"
                                   type="password"
                                   name="oldPassword"
                                   ref="oldPassword"
                                   minLength='6'
                                   maxLength='50'
                                   placeholder={this.rb("profile.old_password")+this.rb("profile.pwdcasesensitive")}
                                   value={this.state.oldPassword}
                                   onChange={this.handlePasswrdChange}
                                   size="40"
                                   required />
                                   <span className="hint" hidden={true} id="oldPasswordHint">{this.rb("profile.pwdcasesensitive")}</span>
                                   <div className="error" id="oldPasswordError" />
                                   </div>


                                   <div className="form-group">
                                   <input id="passwordLabel" className="form-control inputpass"
                                   type="password"
                                   name="password"

                                   ref="password"
                                   minLength='6'
                                   maxLength='50'
                                   placeholder={this.rb("profile.new_password")}
                                   value={this.state.password}
                                   onChange={this.handlePasswrdChange}
                                   size="40"
                                   pattern=".{6,}"
                                   required />
                                   <span className="hint" hidden={true} id="passwordHint">{this.rb("profile.pwdcasesensitive")}</span>
                                   <div className="error" id="passwordError" />
                                   </div>

                                   <div className="form-group">
                                   <input id="passwordConfirmLabel" className="form-control inputpass"
                                   type="password"
                                   name="passwordConfirm"
                                   ref="passwordConfirm"
                                   minLength='6'
                                   maxLength='50'
                                   placeholder={this.rb("profile.confirm_password")}
                                   value={this.state.passwordConfirm}
                                   size="40"
                                   onChange={this.handlePasswrdChange}
                                   required />
                                   <span className="hint" hidden={true} id="passwordConfirmHint">{this.rb("profile.pwdcasesensitive")}</span>
                                   <div className="error" id="passwordConfirmError" />
                                   </div>
                                   </Col>
                                   </Row>
                                   </div>
                                   );
                               }

                           })()}

                           <br />
                           <Row>
                           <Col><label className="label-title"></label></Col>
                           </Row>
                           <Row>
                       {/* <Col xs="12" lg="3" md="4" sm="12"></Col> */}

                       <Col xs="12" lg="12" md="12" sm="12">
                       <div className="btnalign">
                           <span data-ga="My profile - save button">
                           <Button className="btncard alertyes" id="save"  size="lg" disabled={this.dataUpdate} onClick={this.handleSubmit}>{this.rb("profile.save")}</Button>
                               </span>
                       <Button className="btncard alertcancel" id="cancel" size="lg" disabled={this.dataUpdate} onClick={this.handleClear}>{this.rb("profile.cancel")}</Button>
                       </div>
                       </Col>
                       </Row>

                       <Modal isOpen={this.state.modal} className="settingsModalDialog" centered>
                       <ModalHeader >
                       </ModalHeader>

                       <ModalBody>
                       <div className="alertmsg">
                       {this.state.msg}
                       </div>
                       </ModalBody>
                       <ModalFooter>
                       <Button color="Primary" className="alertok" onClick={this.toggle}>{this.rb("alert.ok")}</Button>
                       </ModalFooter>
                       </Modal>

                       </div>
                       </form>
                       );
                   }
               }


               export default ContestProfileSettings;



// WEBPACK FOOTER //
// ./src/views/contest/ContestProfileSettings.js